<template>
  <div class="documents-box">
    <nav class="documents-card">
      <h2>Infoauto Documents</h2>

      <div v-if="loading" class="card-loading">
        <baseMiniSpinner />
      </div>

      <template v-else-if="user && user.data && user.data.length > 0">
        <div class="table-wrapper">
          <table class="default-table">
            <thead>
              <tr>
                <th>Numero Doc</th>
                <th>Num Web</th>
                <th>Tipo</th>
                <th>Emision</th>
                <th>Vencimiento</th>
                <th>Dias credito</th>
                <th>Subtotal</th>
                <th>Total</th>
                <th>Impuestos</th>
                <th>Transporte</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="document in user.data" :key="document.documentoId">
                <td>{{ document.documentoId }}</td>
                <td>{{ document.nroPreimpreso }}</td>
                <td>{{ document.tipoDocumento }}</td>
                <td>{{ document.fEmision | date1 }}</td>
                <td>{{ document.fVencimiento | date1 }}</td>
                <td>{{ document.diasCredito }}</td>
                <td>{{ document.subtotal | currencyFormatted(true) }}</td>
                <td>{{ document.total | currencyFormatted(true) }}</td>
                <td>{{ document.totalImp | currencyFormatted(true) }}</td>
                <td>{{ document.transporte }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <div v-else class="empty-state">
        No documents found for this customer
      </div>
    </nav>
  </div>
</template>
<script>
import { infoautoGetDocumentsCustomer } from "@/api/store/Infoauto.js";
export default {
  props: {
    customerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      user: null,
      loading: true,
      error: false
    };
  },
  async mounted() {
    try {
      this.user = await infoautoGetDocumentsCustomer(this.customerId);
    } catch (error) {
      this.error = true;
    }
    this.loading = false;
  }
};
</script>
<style lang="scss" scoped>
.documents-box {
  width: 100%;
  font-size: 14px;
  color: #1a1a2e;
}

.documents-card {
  @apply p-4 border rounded-md;
  width: 100%;

  h2 {
    font-weight: 700;
    font-size: 16px;
    margin: 0 0 12px 0;
    color: #111827;
  }
}

.card-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.table-wrapper {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.empty-state {
  padding: 20px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
</style>
